function addLeadingZero (t) {
  if (t < 10) return `0${t}`
  return t
}

export default {
  name: 'time',
  filter: function (t) {
    const hours = addLeadingZero(new Date(t).getHours())
    const minutes = addLeadingZero(new Date(t).getMinutes())
    const seconds = addLeadingZero(new Date(t).getSeconds())
    return `${hours}:${minutes}:${seconds}`
  }
}
